import { Component, ViewEncapsulation, input, computed, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgOptimizedImage } from '@angular/common';
import { OverlineComponent } from '../../atoms/overline/overline';

export interface TimelineBlock {
  overline?: string;
  heading: string;
  body: string;
  imageSrc?: string;
  imageAlt?: string;
  imageWidth?: number;
  imageHeight?: number;
}

export type TimelineVariant = 'detection' | 'casestudy';

@Component({
  selector: 'ds-timeline-block',
  templateUrl: './timeline-block.html',
  styleUrl: './timeline-block.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [OverlineComponent, NgOptimizedImage],
})
export class TimelineBlockComponent {
  private readonly sanitizer = inject(DomSanitizer);
  readonly variant = input<TimelineVariant>('detection');
  readonly blocks = input.required<TimelineBlock[]>();

  readonly trustedBlocks = computed(() =>
    this.blocks().map(b => ({
      ...b,
      trustedBody: this.sanitizer.bypassSecurityTrustHtml(b.body),
    })),
  );
}
